import { useEffect, useState } from "react";
import { api } from "@/lib/api";

let cache = null;
export function useBrand() {
  const [brand, setBrand] = useState(cache);
  useEffect(() => {
    if (cache) return;
    api.get("/brand").then((r) => { cache = r.data; setBrand(r.data); }).catch(() => {});
  }, []);
  return brand || { name: "2ndInnings", logo_url: "", tagline: "India's Retired Workforce Marketplace",
                    address: "", email: "", phone: "" };
}
